import { CostCentersAssignmentsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface CostCentersProps {
  applyingOn?: string
  resourceId: string
  resourceType: string
  skipQueries?: boolean
  hasNewStructureEnabled: boolean
}

const useCostCentersAssignments = ({
  resourceId,
  resourceType,
  applyingOn,
  skipQueries = false,
  hasNewStructureEnabled,
}: CostCentersProps) => {
  const { data, loading, refetch } = useQuery(CostCentersAssignmentsDocument, {
    variables: {
      applyingOn,
      resourceId,
      resourceType,
      sourceType: hasNewStructureEnabled ? 'structure_based' : 'legacy',
    },
    skip: skipQueries,
  })

  const assignments = data?.costCenters.assignmentsConnection.nodes || []

  return {
    isLoading: loading,
    assignments,
    refetch,
  }
}

export default useCostCentersAssignments
